import React from 'react';
import sineWave from './sine.gif';

const SmallLoading = () => {
  return <img src={sineWave} alt="Loading..." width={100} height={20} />;
};

export default SmallLoading;



// WEBPACK FOOTER //
// ./src/Components/Loading/SmallLoading.js